<template>
    <div class="w100 bgGrey" style="min-height: 550px;">
        <article class="wContent center" style="padding-top: 10px; padding-bottom: 20px;">
            <!-- 下拉效果广告 -->
            <div class="ad-slide-box" id="adSlideBox"><img @click="ADSlideToggle()"
            		src="../../assets/images/index_slide_little.png" alt="" style="width: 60px; height: 60px;">
            </div>
            <div style="margin-bottom: 10px; height: 0px; overflow: hidden;" id="slideAD">
            	<router-link to="/heitiane" target="_blank">
            		<img src="../../assets/images/index_slide_main2.jpg" alt="" id="adSlideImg" style="display:block;">
                </router-link>
            	<a href="javascript:;" target="_blank">
            		<img src="../../assets/images/index_slide_main2.jpg" alt="" id="adSlideImg"
            			style="display:block;">
            	</a>
            </div>
            
            <div style="margin-bottom: 20px;display: none;">
            	<img height="100" width="1200" src="../../assets/images/bannernew.png"/>
            </div>
            <!-- 下拉效果结束 -->
			
			<div class="mw-fast-list-box">
                <span class="mw-fast-list-sub" :class="{'fontBold fontRed': subNavTab == 0}" @click="changeNav(0)">会议活动</span>
                <span class="mw-fast-list-sub" :class="{'fontBold fontRed': subNavTab == 1}" @click="changeNav(1)">唐宋年会</span>
                <!-- <span class="mw-fast-list-sub" :class="{'fontBold fontRed': subNavTab == 2}" @click="changeNav(2)">签约仪式</span> -->
            </div>
			
            <el-row :gutter="20" class="mw-modular-box" v-show="subNavTab == 0">
                <el-col :span="16">
                    <div class="grid-content">
                        <div class="">
                            <el-carousel height="266px" width="100%">
                                <el-carousel-item>
                                    <a href="javascript:;" @click="goDetail('1')">
                                        <img src="../../assets/images/ej/2020y_top1.jpg" alt="" srcset="" class="w100">
                                    </a>
                                </el-carousel-item>
                                <el-carousel-item>
                                    <a href="javascript:;" @click="goDetail('2')">
                                        <img src="../../assets/images/ej/2021y_top1.jpg" alt="" srcset="" class="w100">
                                    </a>
                                </el-carousel-item>
                                <el-carousel-item>
                                    <a href="javascript:;" @click="goDetail('3')">
                                        <img src="../../assets/images/ej/2021y_top1_jy.jpg" alt="" srcset="" class="w100">
                                    </a>
                                </el-carousel-item>
                                <el-carousel-item>
                                    <a href="javascript:;" @click="goDetail('7')">
                                        <img src="../../assets/images/ej/2021y_top1_ts.jpg" alt="" srcset="" class="w100">
                                    </a>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <div class="bgWhite mw-modular-box p15">
                            <div v-for="(item, index) in tableData" :key="index" @click="goDetail(item.id)">
                                <el-row>
                                    <el-col :span="8">
                                        <img :src="item.img" alt="" srcset="" style="height: 180px; width: 100%">
                                    </el-col>
                                    <el-col :span="16">
                                        <div class="act-txt">
                                            <h3>{{item.title}}</h3>
                                            <p class="act-sub-title">{{item.oprator}}</p>
                                            <p class="act-msg">时间：{{ item.time }}</p>
                                            <p class="act-msg">地点： {{ item.address }}</p>
                                            <p class="act-msg">规模：{{item.members}}人</p>
                                            <p class="textRight"><el-button type="danger" size="mini" @click="goDetail(item.id)">立即前往</el-button></p>
                                        </div>
                                    </el-col>
                                </el-row>
                                <hr class="mw-modular-box" style="background-color: #ccc; height: 1px; border: none">
                            </div>
                        </div>
                        
                        <div class="textCenter" style="padding-top: 30px">
                            <el-button class="load-more-btn" @click="loadMore()" v-show="isShowLoad">+ 加载更多</el-button>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <div class="bgWhite cover p15">
                            <h4 style="margin-bottom: 10px;">年会报道</h4>
                            <div class="mw-ranking">
                                <div class="mw-ranking-list" v-for="(item, index) in coverData" :key="index">
                                    <div> <span :class="{ 'mw-ranking-index-top': index < 3, 'mw-ranking-index': index >= 3 }">{{ index + 1 }}</span> </div>
                                    <div>
                                        <a :href="item.link" target="_blank">{{ item.title }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="ad mw-modular-box" v-show="adIDsIndex[1] && adIDsIndex[1]['list'].length > 0">
                            <a :href="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adLink'] : '') : ''" target="_blank">
                                <img :src="adIDsIndex[1] ? (adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adPicturePath'] : '') : ''" alt="" style="height: 100px;" class="w100">
                            </a>
                        </div>

                        <div class="bgWhite cover p15 mw-modular-box">
                            <h4 style="margin-bottom: 10px;">会务联系</h4>
                            <div class="mw-ranking">
                                <p>河北唐宋大数据产业股份有限公司</p>
                                <p>会务联系人：王慧</p>
                                <p>联系方式：18231525225</p>
                                <p>回执传真至：0315-5921091/92</p>
                                <el-row style="margin-top: 10px">
                                    <el-col :span="8">
                                        <div class="textCenter">
                                            <img src="../../assets/images/act_code1.png" alt="" width="80px">
                                            <small style="display: block;line-height: 40px;">在线监测预警公众号</small>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="textCenter">
                                            <img src="../../assets/images/footer_down.png" alt="" width="80px">
                                            <p style="line-height: 35px;">唐宋app</p>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="textCenter">
                                            <img src="../../assets/images/footer_code.png" alt="" width="80px">
                                            <p style="line-height: 35px;">唐宋大数据</p>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>

                    </div>
                </el-col>
            </el-row>

            <!-- 唐宋年会------------------ -->
            <el-row :gutter="20" class="mw-modular-box" v-show="subNavTab == 1">
                <el-col :span="16" style="margin-top: -20px">
                    <div class="grid-content">
                        <div class="bgWhite mw-modular-box p15 meeting">
                            <div v-for="(item, index) in meetingData" :key="index">
                                <el-row>
                                    <el-col :span="8">
                                        <img :src="item.img" alt="" srcset="" style="height: 180px; width: 100%">
                                    </el-col>
                                    <el-col :span="16">
                                        <div class="act-txt">
                                            <h3><span class="inlineBlock ellipsis" style="width: 80%;">{{item.title}}</span><a :href="item.link" target="_blank" class="fontRed floatRight" style="font-size: 15px;">年会盛况 >></a></h3>
                                            <p class="act-sub-title act-sub-titleO" :id="'sub_' + index">{{item.remark}}</p>
                                            <p class="textRight" :id="'show_' + index"><a href="javascript:;" class="overflow" @click="showAllRemark(index)">展开 <i class="el-icon-bottom"></i></a></p>
                                        </div>
                                    </el-col>
                                </el-row>
                                <hr class="mw-modular-box" style="background-color: #ccc; height: 1px; border: none">
                            </div>
                        </div>
                        
                        <div class="textCenter" style="padding-top: 30px">
                            <el-button class="load-more-btn" @click="loadMoreMeeting()" v-show="isShowLoadMeeting">+ 加载更多</el-button>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <!-- <div class="bgWhite cover p15">
                            <h4 style="margin-bottom: 10px;">会议活动</h4>
                            <div class="">
                                <img src="../../assets/images/index_slide_main.png" alt="" style="width: 100%">
                                <h3 style="font-size: 15px; line-height: 35px">唐宋钢铁市场研讨会暨日照大商调期交易推介会</h3>
                                <p>邯郸   2020年9月25日</p>
                            </div>
                        </div> -->

                        <!-- <div class="ad mw-modular-box" v-show="adIDsIndex[1] && adIDsIndex[1]['list'].length > 0">
                            <a :href="adIDsIndex[1] ? ( adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adLink'] : '') : ''" target="_blank">
                                <img :src="adIDsIndex[1] ? (adIDsIndex[1]['list'].length > 0 ? adIDsIndex[1]['list'][0]['adPicturePath'] : '') : ''" alt="" style="height: 100px;" class="w100">
                            </a>
                        </div> -->

                        <div class="bgWhite cover p15">
                            <h4 style="margin-bottom: 10px;">会务联系</h4>
                            <div class="mw-ranking">
                                <p>河北唐宋大数据产业股份有限公司</p>
                                <p>服务热线：400-6565-958</p>
                                <p>电话：0315-5921001/400-6565-958</p>
                                <p>传真：0315-5921091/5921092</p>
                                <p>E-mail：info@chinatsi.com</p>
                                <el-row style="margin-top: 10px">
                                    <el-col :span="8">
                                        <div class="textCenter">
                                            <img src="../../assets/images/act_code1.png" alt="" width="80px">
                                            <small style="display: block;line-height: 40px;">在线监测预警公众号</small>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="textCenter">
                                            <img src="../../assets/images/footer_down.png" alt="" width="80px">
                                            <p style="line-height: 35px;">唐宋app</p>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="textCenter">
                                            <img src="../../assets/images/footer_code.png" alt="" width="80px">
                                            <p style="line-height: 35px;">唐宋大数据</p>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>

                        

                    </div>
                </el-col>
            </el-row>

            <!-- 签约仪式------------------ -->
            <div v-show="subNavTab == 2" class="bgWhite" style="padding-bottom: 10px">
                <el-row :gutter="20" class="mw-modular-box">
                    <el-col :span="8">
                        <div class="p10">
                            <img src="../../assets/images/index_slide_main.png" alt="" class="w100">
                            <p class="signUp-title textCenter">陕钢集团经营导航系统  项目签约仪式</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="p10">
                            <img src="../../assets/images/index_slide_main.png" alt="" class="w100">
                            <p class="signUp-title textCenter">陕钢集团经营导航系统  项目签约仪式</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="p10">
                            <img src="../../assets/images/index_slide_main.png" alt="" class="w100">
                            <p class="signUp-title textCenter">陕钢集团经营导航系统  项目签约仪式</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="p10">
                            <img src="../../assets/images/index_slide_main.png" alt="" class="w100">
                            <p class="signUp-title textCenter">陕钢集团经营导航系统  项目签约仪式</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="p10">
                            <img src="../../assets/images/index_slide_main.png" alt="" class="w100">
                            <p class="signUp-title textCenter">陕钢集团经营导航系统  项目签约仪式</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="p10">
                            <img src="../../assets/images/index_slide_main.png" alt="" class="w100">
                            <p class="signUp-title textCenter">陕钢集团经营导航系统  项目签约仪式</p>
                        </div>
                    </el-col>
                </el-row>
                <el-pagination @current-change="handleCurrentChange" :current-page="pageNum2" :page-size="6" layout="total, prev, pager, next, jumper" :total="signUpTotal">
                </el-pagination>
            </div>

        </article>

        <ConcatsControl></ConcatsControl>
    </div>
</template>
<script>

import $ from 'jquery'
import { baseUrl, adIDs } from '../../assets/js/common'
import data from '../../assets/js/activities.json'
import coverData from '../../assets/js/activitiesCover.json'
import meetingData from '../../assets/js/meeting.json'
import signUpData from '../../assets/js/signUp.json'
import ConcatsControl from '../../templates/concatsControl'
export default {
    name: 'Activities',
    components: { ConcatsControl },
    data() {
        return {
            adIDsIndex: [{
                name: 'indexSwiper',
                id: adIDs['indexSwiper'],
                list: []
            },{
                name: 'zx39',
                id: adIDs['zx39'],
                list: []
            }],
            subNavTab: 0,
            pageNum: 0,
            pageNum1: 0,
            pageNum2: 1,
            tableData: [],
            coverData: coverData.data,
            meetingData: [],
            isShowLoad: true,
            isShowLoadMeeting: true,
            signUpTotal: signUpData.totalNum
        }
    },
    mounted () {
        this.getAdByAdp();
        this.loadMore();
        this.loadMoreMeeting();
    },
    methods: {
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
						
						const height = $(window).height();
						$('#adSlideImg').height(height - 105)
						setTimeout(() => {
							//self.ADSlideToggle();
						}, 3000)
                    }
                })
            })
        },
		
		// 广告下滑特效
		ADSlideToggle() {
			const height = $(window).height();
			const imgWidth = (height - 103) * 2.5;
			$('#adSlideImg').css({
				'margin-left': ('-' + (imgWidth - 1200) / 2 + 'px'),
				'width': imgWidth
			});
		
			$('#slideAD').animate({
				'height': height - 103
			}, 2000, () => {
				setTimeout(() => {
					$('#slideAD').animate({
						'height': '0px'
					}, 2000, () => {
						$('#adSlideBox').animate({
							'opacity': '1',
							'top': '90%'
						}, 2000, () => {})
					});
				}, 3000)
			})
		},
		
        // 加载更多
        loadMore () {
            const self = this;
            let newData = [];
            if (5 * (self.pageNum + 1) < data.data.length) {
                newData = data.data.slice(5*self.pageNum, 5*(self.pageNum + 1));
                self.pageNum += 1;
            } else {
                newData = data.data.slice(5*self.pageNum, data.data.length);
                self.isShowLoad = false;
            }
            self.tableData = self.tableData.concat(newData);
        },
        goDetail(id) {
            if (id == 1) {
                this.$router.push(`/home/activitiesDetail?id=${id}`)
            } else {
                this.$router.push(`/home/activitiesDetail${id}`)
            }
        },
        changeNav(tab) {
            this.subNavTab = tab;
        },
        // 会议
        // 加载更多
        loadMoreMeeting () {
            const self = this;
            let newData = [];
            if (5 * (self.pageNum1 + 1) < meetingData.data.length) {
                newData = meetingData.data.slice(5*self.pageNum1, 5*(self.pageNum1 + 1));
                self.pageNum1 += 1;
            } else {
                newData = meetingData.data.slice(5*self.pageNum1, meetingData.data.length);
                self.isShowLoadMeeting = false;
            }
            newData.forEach(item => {
                if (item.img && (item.img.startsWith('../') || item.img.startsWith('./'))) {
                    item.img = require('../../assets/images/26suoluetu.jpg');
                }
            });
            self.meetingData = self.meetingData.concat(newData);
        },
        goMeetingDetail(id) {
            this.$router.push(`/home/activitiesDetail?id=${id}`)
        },
        // 展开描述
        showAllRemark (index) {
            $('#sub_' + index).removeClass('act-sub-titleO');
            $('#show_' + index).css({'display': 'none'});
        },

        // 签约仪式
        getSignUpData() {

        },
        handleCurrentChange (page) {
            this.pageNum2 = page;
            this.getSignUpData();
        }
    }
    
}
</script>

<style scoped>
    .act-txt { padding-left: 15px; }
    .act-txt h3 { font-size: 18px; color: #555; font-weight: normal; line-height: 45px; }
    .act-sub-title { font-size: 14px; line-height: 30px; color: #555; }
    .act-msg { color: #aaa; line-height: 25px; }
    .cover h4 { padding-left: 10px; border-left: 8px solid #a30000; font-size: 16px; line-height: 25px; }
    .cover { font-size: 14px; }
    .cover p { line-height: 30px; }
    .meeting .act-sub-titleO { 
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
    }
    .meeting .overflow { color: cornflowerblue; font-size: 15px;}
    .signUp-title { font-size: 16px; line-height: 60px; }
</style>